import { ToggleButton, ToggleButtonGroup } from '@chronosphereio/chrono-ui';
import { useQueryEditorContext } from './query-editor-context';

export interface QueryEditorModeToggleProps {
  modes: string[];
  disabled?: boolean;
}

/**
 * Exclusive mode toggle. Reads `mode` and `onModeChange` from `useQueryEditorContext()`.
 *
 * Requires `QueryEditor.Root` to receive both `mode` and `onModeChange`. The context `mode` should be one of
 * `modes` so the toggle group can show a selection; otherwise behavior follows the underlying toggle group.
 */
export function QueryEditorModeToggle({ modes, disabled }: QueryEditorModeToggleProps) {
  const { mode, onModeChange } = useQueryEditorContext();

  if (mode === undefined || onModeChange === undefined) {
    throw new Error('QueryEditor.ModeToggle requires QueryEditor.Root to receive `mode` and `onModeChange` props.');
  }

  return (
    <ToggleButtonGroup<string>
      value={mode}
      disabled={disabled}
      onChange={(_event, next) => {
        onModeChange(next);
      }}
    >
      {modes.map((m) => (
        <ToggleButton key={m} value={m} sx={{ height: 24, fontSize: 'small' }}>
          {m.length > 0 ? m.charAt(0).toUpperCase() + m.slice(1) : m}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
